import screenConfigFindTutor from "./screenConfigFindTutor";
import screenConfigFindJob from "./screenConfigFindJob";
import screenConfigPrivate from "./screenConfigPrivateNachhilfe";
import screenConfigComparison from "./screenConfigComparison";

import validateInput from "./_validateInput";

tutorMatching = {};

var imgPath = '/static/images/';
var apiUrl = '/data/tutors/list';
var screenConfig;

formData = {
	subject: '',
	subjects: [],
	type: [],
	department: [],
	location: [],
	level: '',
	grade: '',
	timeframe: '',
	gender: '',
	school: '',
	city: '',
	time: '',
	intent: [],
	timeslots: [],
	message: '',
	current_situation_general: '', //online_learning_current_situation - hs select name
	current_situation_support: '', //online_learning_current_situation_support
	opinion_online_tutoring: '', //online_learning_general_opinion
};

var isPrivateNh = document.querySelector('.tutor-matching-container').classList.contains('private-nachhilfe');
var isComparison = document.querySelector('.tutor-matching-container').classList.contains('comparison');
var isNewStackedCardsDesign = document.querySelector('.tutor-matching-container').classList.contains('right-side');
var isFindJob = document.querySelector('.tutor-matching-container').classList.contains('find-job');
var isOnlineNh = false;


tutorMatching.UiController = {
	activeScreen: null,
  activeIndex: 0,
  isBgSwitching: false,
  bgIndex: 0,
  bgImgs: [],
  serialize: function(obj) {
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    return str.join("&");
  },
  fetchResult: function() {
    var that = this;
    var subject = tutorMatching.collectedInputs.subject;
    var gender = tutorMatching.collectedInputs.gender;
		var audience = tutorMatching.collectedInputs.level;
		var weekdays = tutorMatching.collectedInputs.timeframe;
		var school = tutorMatching.collectedInputs.school;
		var intent = tutorMatching.collectedInputs.intent;
    var prepStart = tutorMatching.collectedInputs['prep-start'];
    var lang = document.getElementById('lang');

    var queryData = {
      subject: subject,
			gender: gender,
			audience: audience,
			weekdays: weekdays,
			intent: intent,
    }
    
    if (lang && lang.value) {
      queryData.lang = lang.value;
    }

	var queryString = this.serialize(queryData);
	// Overwriting apiUrl cause they're later fetched and we have two designs now
	if (isNewStackedCardsDesign) {
		queryString += "&newStackedCards=true"
	}
    queryString += '&stdlist=true';
	
    $.getJSON( apiUrl + '?' + queryString, function( data ) {
      if (data) {
				var node = $('#stackedCards');
		var elements = $(data.Html);
		elements = elements.filter('div');
        (function($){
          $.fn.shuffle = function() {
              var allElems = this.get(),
                  getRandom = function(max) {
                      return Math.floor(Math.random() * max);
                  },
                  shuffled = $.map(allElems, function(){
                      var random = getRandom(allElems.length),
                          randEl = $(allElems[random]).clone(true)[0];
                      allElems.splice(random, 1);
                      return randEl;
                  });
              this.each(function(i){
               
                var titleIndex = i + 1;
				const title = $(shuffled[i]).find('.title').text();
                $(shuffled[i]).find('.title').text(title + ' #' + titleIndex);
                $(this).replaceWith($(shuffled[i]));
              });

              return $(shuffled).remove('.not-found');

          };

        })($);

        var lastItem = elements[elements.length -1];
        elements = elements.slice(0,-1).shuffle();
        elements.push(lastItem);

				node.html(elements);

				if (!data.Raw && !isOnlineNh) {
					screenConfig[that.activeIndex + 1].title = ''
				}
        setTimeout(function() {
					if (document.querySelector('#selectedSubject')) document.querySelector('#selectedSubject').value = subject;
					if (document.querySelector('#selectedSchool')) document.querySelector('#selectedSchool').value = school;
					if (document.querySelector('#prepStart')) document.querySelector('#prepStart').value = prepStart;
          that.navNext();
        }, 300);
      }
    })
	},
	setTitle: function(title) {
		var titleElement = document.querySelector('.js-title');
		if (titleElement) {
			if (title && titleElement) {
				titleElement.innerHTML = title;
				titleElement.classList.remove('hidden');
			} else {
				titleElement.classList.add('hidden');
			}
		}
	},
	setSubtitle: function(title) {
		var titleElement = document.querySelector('.js-subtitle');
		if (titleElement) {
			if (title && titleElement) {
				titleElement.innerHTML = title;
				titleElement.classList.remove('hidden');
			} else {
				titleElement.classList.add('hidden');
			}
		}
	},

	setInputTitle: function(title) {
		var titleElement = document.querySelector('.js-input-title');
		if (titleElement) {
			if (title) {
				titleElement.innerText = title;
				titleElement.classList.remove('hidden');
			} else {
				titleElement.classList.add('hidden');
			}
		}
	},
	setInputProgress: function(progress, hideProgress) {
		if (document.querySelector('.js-progress')) {
			setTimeout(function() {
				var progressBar = document.querySelector('.js-progress');
				var progressBarContainer = progressBar.parentElement;
				progressBar.style.width = progress;
				if (hideProgress) {
					progressBarContainer &&  progressBarContainer.classList.add('hidden');
				} else {
					progressBarContainer && progressBarContainer.classList.remove('hidden');
				}
			}, 300);
		}
	},
	getBackground: function(screenconf) {
    const isMobile = window && window.innerWidth < 992;
    const bg = isMobile && screenconf.backgroundMobile ? screenconf.backgroundMobile : screenconf.background;
    return bg;
  },
	setBackground: function(background) {
    var that = this;
    if (!that.isBgSwitching) {
      that.isBgSwitching = true;
      var bgs = document.querySelectorAll('.bg-container');
      var active = document.querySelector('.bg-container.active');
      for (i = 0; i < bgs.length; i++ ) {
        if (active === bgs[i]) {
          active.style.zIndex = -2;
          setTimeout(function() {
            active.classList.remove('active');
            active.style.zIndex = -1;
            active.style.backgroundImage = 'url(\''+ imgPath + background +'\')';
            that.isBgSwitching = false;
          },500);
        } else {
          bgs[i].classList.add('active');
        }
      }

      if (that.bgIndex == that.bgImgs.length -1 ) {
        that.bgIndex = 0;
      } else {
        that.bgIndex++;
       }
     }
  },
  getContent: function(screenconf) {
		const el = document.querySelector('#' + screenconf.id);
		if (el) {
			screenconf.title = el.dataset.title;
			screenconf.subtitle = el.dataset.subtitle;
			screenconf.background = el.dataset.bg;
			if (screenconf.isInputScreen) {
				screenconf.inputScreen = screenconf.inputScreen || {};
				screenconf.inputScreen.title = el.dataset.inputtitle;
			}
			return screenconf;
		}
		
		return null;
  },
	renderScreen: function(screenconf) {
    screenconf = this.getContent(screenconf);
		if (!screenconf) {
			tutorMatching.UiController.navNext();
			return;
		}

		this.setTitle(screenconf.title);
		this.setSubtitle(screenconf.subtitle);
		const bg = this.getBackground(screenconf);
		if (screenconf.background) this.setBackground(bg);
		if (this.activeScreen) {
			this.activeScreen.classList.remove('active');
			var forms = document.querySelectorAll('.js-input');
			for(var i = 0; i < forms.length; i++) {
				forms[i].classList.remove('active');
			}
		}

		var cc = document.querySelector('.content');
		if (screenconf.isInputScreen) {
			this.setInputTitle(screenconf.inputScreen.title);
			this.activeScreen = document.querySelector('#inputScreen');
      document.querySelector('#' + screenconf.id) && document.querySelector('#' + screenconf.id).classList.add('active');
			this.setInputProgress(screenconf.inputScreen.progress, screenconf.inputScreen.hideProgress);
			cc.classList.remove('narrow');
			cc.classList.add('push');
		} else {
			this.activeScreen = document.querySelector('#' + screenconf.id);
			cc.classList.remove('push');
			cc.classList.add('narrow');
		}

		if (screenconf.onLoad) screenconf.onLoad();
		var that = this;
		setTimeout(function() {
			that.activeScreen.classList.add('active');
		}, 300);
	},

	navNext: function() {
		if (this.activeIndex < screenConfig.length - 1) {
			this.activeIndex = this.activeIndex + 1;
			this.renderScreen(screenConfig[this.activeIndex]);
		}
	},

	navPrev: function() {
		if (this.activeIndex > 0) {
			this.activeIndex = this.activeIndex - 1;
			this.renderScreen(screenConfig[this.activeIndex]);
		}
  },

  cacheBackgrounds: function() {
    var that = this;
    for (i= 0; i< screenConfig.length; i++) {
      if (screenConfig[i] && screenConfig[i].background) {
        const c = this.getContent(screenConfig[i])
        new Image().src = imgPath + c.background;
        that.bgImgs[i] = imgPath + c.background;
      }
    }
  },

	initUi: function() {
    this.cacheBackgrounds();
		tutorMatching.collectedInputs = formData;
		var subject = document.querySelector('#selectedSubject') ? document.querySelector('#selectedSubject').value : '';
		if (subject && subject.length) {
			tutorMatching.collectedInputs.subject = subject;
		}
    this.activeIndex = 0;
    this.renderScreen(screenConfig[this.activeIndex]);
	}
}

$(document).ready(function(event) {
	var dataHandler = function(evt, key) {
		evt.preventDefault();
		var form = evt.target;
		var input = form.querySelector('input');
    var data = new FormData(form);
    const val = data.get(key);
	tutorMatching.collectedInputs[key] = val;

    if (validateInput(input)) {
      tutorMatching.UiController.navNext();
    }

		return false;
	}

	document.querySelector('#city') && document.querySelector('#city').addEventListener('submit', function(evt) {
		dataHandler(evt, evt.target.id);
  }, false);
  
  document.querySelector('#zip') && document.querySelector('#zip').addEventListener('submit', function(evt) {
		dataHandler(evt, evt.target.id);
	}, false);

	document.querySelector('#message') && document.querySelector('#message').addEventListener('submit', function(evt) {
		dataHandler(evt, evt.target.id);
	}, false);

	document.querySelector('#subject') && document.querySelector('#subject').addEventListener('submit', function(evt) {
		dataHandler(evt, evt.target.id);
	}, false);

	document.querySelector('#subjects') && document.querySelector('#subjects').addEventListener('submit', function(evt) {
		evt.preventDefault();
		tutorMatching.UiController.navNext();
	}, false);

	document.querySelector('#intent') && document.querySelector('#intent').addEventListener('submit', function(evt) {
		evt.preventDefault();
		tutorMatching.UiController.navNext();
	}, false);

	document.querySelector('#timeslots') && document.querySelector('#timeslots').addEventListener('submit', function(evt) {
		evt.preventDefault();
		tutorMatching.UiController.navNext();
	}, false);

	document.querySelector('#school') && document.querySelector('#school').addEventListener('submit', function(evt) {
		dataHandler(evt, evt.target.id);
	}, false);

	document.querySelector('#area') && document.querySelector('#area').addEventListener('submit', function(evt) {
		dataHandler(evt, evt.target.id);
	}, false);

	document.querySelector('#prep-start') && document.querySelector('#prep-start').addEventListener('submit', function(evt) {
		dataHandler(evt, evt.target.id);
	}, false);

	document.querySelector('#type') && document.querySelector('#type').addEventListener('submit', function(evt) {
		evt.preventDefault();
		tutorMatching.UiController.navNext();
	}, false);

	document.querySelector('#department') && document.querySelector('#department').addEventListener('submit', function(evt) {
		evt.preventDefault();
		tutorMatching.UiController.navNext();
	}, false);

	document.querySelector('#location') && document.querySelector('#location').addEventListener('submit', function(evt) {
		evt.preventDefault();
		tutorMatching.UiController.navNext();
	}, false);

	document.querySelector('#result') && document.querySelector('#result').addEventListener('submit', function(evt) {
		evt.preventDefault();
		document.querySelector('body').classList.add('noscroll');
		document.querySelector('#hubspot-overlay') && 	document.querySelector('#hubspot-overlay').classList.remove('show-all-fields');
		document.querySelector('#hubspot-overlay') && document.querySelector('#hubspot-overlay').classList.add('active');
		setTimeout(function() {
			var timeframe = tutorMatching.collectedInputs['timeframe'];
			var subjects = tutorMatching.collectedInputs['subjects'];
			$('.hs_tutoring_subjects').find('input[type="checkbox"]').prop('checked', false);
			subjects.forEach(function(subject) {
				var subjectOption =  $('.hs_tutoring_subjects').find('input[value="' + subject + '"]');
				if(subjectOption && subjectOption.length > 0) {
					// important: call change() after setting value, otherwise hubspot overwrites them
					subjectOption.prop('checked',true).change();
				}

			});
			// important: call change() after setting value, otherwise hubspot overwrites them
			$('.hs_availability_for_tutoring').find('input').val(timeframe).change();

		}, 2000)

	}, false);

	var openOverlayBtns = document.querySelectorAll('.js-open-hs-overlay');
	if (openOverlayBtns && openOverlayBtns.length > 0) {
		for(i = 0; i < openOverlayBtns.length; i++) {
			openOverlayBtns[i].addEventListener('click', function() {
				document.querySelector('#hubspot-overlay') && document.querySelector('#hubspot-overlay').classList.add('show-all-fields');
				document.querySelector('body').classList.add('noscroll');
				document.querySelector('#hubspot-overlay') && document.querySelector('#hubspot-overlay').classList.add('active');
			});
		}
	}

	var btns = document.querySelectorAll('.btn-select, .subject_card');
	var btnSelectHandler = function(evt) {
		var form = evt.target.closest('form');
		var key = form.id;
		var val = evt.target.getAttribute('data-value');
		var subjectCard = evt.target.closest('.subject_card');
		if (subjectCard) {
			var subjectHubspotId = $(subjectCard).find('.subject_name')[0].getAttribute('data-hubspot-id');
			val = subjectHubspotId ? subjectHubspotId : $(subjectCard).find('.subject_name')[0].innerHTML;

			if ($('.js-form-abtest').length) {
				var subjectOption =  $('select[name="trial_session_subject"]').find('option[value="' + val + '"]');
				if(subjectOption && subjectOption.length ) {
					subjectOption.prop('selected',true).change();
				}
			}
		} else {
			if (!val) {
				val = evt.currentTarget.getAttribute('data-value');
			}	
		}

		if (evt.target.classList.contains('multi')) {
			let values = tutorMatching.collectedInputs[key] || []

			if (values.indexOf(val) > -1) {
				values = values.filter(v => v !== val);
				evt.target.classList.remove('active');
			} else {
				values.push(val);
				evt.target.classList.add('active');
			}
			tutorMatching.collectedInputs[key] = values;

			var timeslotCard = evt.target.closest('.time_slot_card');
			if (timeslotCard && !evt.target.classList.contains('clear-multi')) {
				var noneWorksBtn = document.querySelector('div.clear-multi.active');
				if (noneWorksBtn) {
					noneWorksBtn.classList.remove('active');
					values = values.filter(v => v !== noneWorksBtn.attributes['data-value'].value);
					tutorMatching.collectedInputs[key] = values;
				}

				if (values && values.length > 1) {
					form.querySelector('input[type="submit"]') && form.querySelector('input[type="submit"]').classList.remove('disabled')
				} else {
					form.querySelector('input[type="submit"]') && form.querySelector('input[type="submit"]').classList.add('disabled')
				}
			} else {
				if (values && values.length > 0) {
					form.querySelector('input[type="submit"]') && form.querySelector('input[type="submit"]').classList.remove('disabled')
				} else {
					form.querySelector('input[type="submit"]') && form.querySelector('input[type="submit"]').classList.add('disabled')
				}

				if (timeslotCard && evt.target.classList.contains('clear-multi')) {
					var btns = document.querySelectorAll('.time_slot_card.multi.active');
					for (i = 0; i < btns.length; i++) {
						if (!btns[i].classList.contains('clear-multi')) {
							btns[i].classList.remove('active');
						}
						tutorMatching.collectedInputs[key] = ['none works'];
					}
				}
			}

		} else {
			tutorMatching.collectedInputs[key] = val;
			tutorMatching.UiController.navNext();
		}
	}

	for (i = 0; i < btns.length; i++ ) {
		btns[i].addEventListener('ontouchstart', function(evt) {
			btnSelectHandler(evt);
		});
		btns[i].addEventListener('click', function(evt) {
			btnSelectHandler(evt);
		});
	}

	var skipToNext = document.querySelectorAll('.js-skip');
	for (i = 0; i < skipToNext.length; i++) {
		skipToNext[i].addEventListener('click', function(evt) {
			tutorMatching.UiController.navNext();
		});
  }
  
  screenConfig = screenConfigFindTutor.get(tutorMatching);
  if (isPrivateNh) screenConfig = screenConfigPrivate.get(tutorMatching);
  if (isComparison) screenConfig = screenConfigComparison.get(tutorMatching);
  if (isFindJob) screenConfig = screenConfigFindJob.get(tutorMatching);

	tutorMatching.UiController.initUi();
});